// Sample preset images per video action (mirrors p0rn videoActionsConfig).
// Each entry is a 1-based sample index → CDN thumbnail URL. Picked by the user
// in PhotoCreatePopup instead of going through the custom photo flow.

const CDN = "https://genres.nyc3.cdn.digitaloceanspaces.com/thumbnails/video_gen/images";

const file = (name) => `${CDN}/${name}`;

export const VIDEO_SAMPLES = {
    reverse_cowgirl: [
        file("reverse_cowgirl1_thumbnail.jpg"),
        file("reverse_cowgirl2_thumbnail.jpg"),
        file("reverse_cowgirl3_thumbnail.jpg"),
        file("reverse_cowgirl4_thumbnail.jpg"),
    ],
    blowjob: [
        file("blowjob1_thumbnail.jpg"),
        file("blowjob2_thumbnail.jpg"),
        file("blowjob3_thumbnail.jpg"),
        file("blowjob4_thumbnail.jpg"),
    ],
    cumshot: [
        file("cumshot1_thumbnail.jpg"),
        file("cumshot2_thumbnail.jpg"),
        file("cumshot3_thumbnail.jpg"),
        file("cumshot4_thumbnail.jpg"),
    ],
    fingering: [
        file("fingering1_thumbnail.jpg"),
        file("fingering2_thumbnail.jpg"),
        file("fingering3_thumbnail.jpg"),
        file("fingering4_thumbnail.jpg"),
    ],
    fisting: [
        file("fisting1_thumbnail.jpg"),
        file("fisting2_thumbnail.jpg"),
        file("fisting3_thumbnail.jpg"),
        file("fisting4_thumbnail.jpg"),
    ],
    full_nelson: [
        file("full_nelson1_thumbnail.jpg"),
        file("full_nelson2_thumbnail.jpg"),
        file("full_nelson3_thumbnail.jpg"),
        file("full_nelson4_thumbnail.jpg"),
    ],
    posing: [
        file("posing1_thumbnail.jpg"),
        file("posing2_thumbnail.jpg"),
        file("posing3_thumbnail.jpg"),
        file("posing4_thumbnail.jpg"),
    ],
    pov_insertion: [
        file("pov_insertion1_thumbnail.jpg"),
        file("pov_insertion2_thumbnail.jpg"),
        file("pov_insertion3_thumbnail.jpg"),
        file("pov_insertion4_thumbnail.jpg"),
    ],
    rimming: [
        file("rimming1_thumbnail.jpg"),
        file("rimming2_thumbnail.jpg"),
        file("rimming3_thumbnail.jpg"),
        file("rimming4_thumbnail.jpg"),
    ],
    titfuck: [
        file("titfuck1_thumbnail.jpg"),
        file("titfuck2_thumbnail.jpg"),
        file("titfuck3_thumbnail.jpg"),
        file("titfuck4_thumbnail.jpg"),
    ],
    twerking: [
        file("twerking1_thumbnail.jpg"),
        file("twerking2_thumbnail.jpg"),
        file("twerking3_thumbnail.jpg"),
        file("twerking4_thumbnail.jpg"),
    ],
};

export function getSamplesForAction(actionKey) {
    return VIDEO_SAMPLES[actionKey] || [];
}
